export default {
  // Data
  loading: true,

  // Timers
  currentTimestamp: null,
  fetchedTimestamp: null,
  intervalId: null, // Just to clear on clean up.

  // dashboard summary datas(mainly for delivery. For company, getters is being used)
  lastUpdatedAt: null,
  tankInfo: {
    installed: 0, // 圏内の所持センサー数
    total: 0 // 圏内の設置済みセンサー数
  },
  weeklyArray: [],
  monthlyArray: [],
  yearly: [
    {
      // [0]昨シーズンの累計
      count: 0,
      amount: 0
    },
    {
      // [1]今シーズンの現時点での累計
      count: 0,
      amount: 0
    }
  ],
  yesterdayData: {
    count: 0,
    amount: 0
  },
  weatherData: [],

  // Display
  isDelivery: false,
  area: null, // Number. default === user's groupId
  selectedSpan: 0, // 0 === 週, 1 === 月
  chartLoader: true,
  weatherInfoLoader: true
}
